import React from "react";
import { Grid } from "@material-ui/core";
import { RootStateOrAny, useSelector } from "react-redux";

import { Wrapper, ETimer } from "../styles";
import { checarTitulo } from "../../../../../../utils/sharedFunctions";
import { expressaoRepeticoes } from "../Componentes/estruturaExpressao";
import { variaveisRepeticoes } from "../Componentes/estrurturaAlgoritmos";
import { ITreinamentoProps } from "../../../../../../models";

export default function TipoRepeticoes({ expressao }: ITreinamentoProps) {
  const [tempoRestante, setTempoRestante] = React.useState(60);
  const { listagemDeVariavel, nivelSelecionado } = useSelector(
    (state: RootStateOrAny) => state.appSystem
  );

  React.useEffect(() => {
    if (tempoRestante > 0) {
      setTimeout(() => {
        setTempoRestante(tempoRestante - 1);
      }, 1000);
    } else {
      setTempoRestante(0);
    }

    return () => {};
  }, [tempoRestante]);

  return (
    <Wrapper>
      <h3>Algoritmo Repetições - {checarTitulo(nivelSelecionado)}</h3>
      <ETimer>
        Tempo restante: <span>{tempoRestante}s</span>
      </ETimer>
      <Grid item className="no-select">
        {listagemDeVariavel &&
          variaveisRepeticoes(nivelSelecionado, listagemDeVariavel)}
        <br />
        {listagemDeVariavel &&
          expressaoRepeticoes(nivelSelecionado, expressao, listagemDeVariavel)}
      </Grid>
    </Wrapper>
  );
}
